import { Event } from '../interfaces';

export const isAggregableEvent = (event: Event): boolean => {
  return !!event?.sub_events && Array.isArray(event.sub_events) && event.sub_events.length > 1;
};
